export default {
	create: 'erstellen',
	edit: 'bearbeiten',
	type: 'schreiben',
	title: 'Titel',
	description: 'Beschreibung',
	isActive: 'aktiver Status',
	forAllUsers: 'For all users',
	editor: 'Last edited by',
	active: 'Aktiv',
	all: 'Alle',
	disactive: 'Inaktiv',
	global: 'Global',
	local: 'Für autorisierte Nutzer',
	titleEN: 'Englischer Titel',
	titleDE: 'Deutscher Titel',
	descriptionEN: 'Beschreibung auf Englisc',
	descriptionDE: 'Beschreibung auf Deutsch',
	warning: 'Warnung',
	success: 'Erfolg',
	info: 'Info',
	danger: 'Gefahr',
};
